import axios from "../axiosConfig";
import { ENDPOINT_SUBS_RETRIEVE, ENDPOINT_SUBS_UPDATE } from "../../constants";

export function retrieveSubs() : Promise<any> {
    return new Promise<string>( async (resolve, reject) => {
        axios.get(ENDPOINT_SUBS_RETRIEVE, {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
    
}

export function updateAccessStatus(app:string,status:string) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_SUBS_UPDATE, {
            app: app,
            status: status
        }, {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}